import css from 'styled-jsx/css'
import { fontWeights, colors } from 'theme'

export const codeVerificationStyles = css`
  .code-verification-message {
    margin-top: 0;
    text-align: center;
  }
`

export const sendCodeVerificationStyles = css`
  .send-code-verification-message {
    margin-top: 0;
    text-align: center;
  }
  .send-code-verification-message p {
    margin-top: 0;
  }

  .send-code-button-container :global(.send-code-button) {
    padding: 0 2rem;
    font-weight: ${fontWeights.semiBold};
  }
`

export const deviceHeaderStyles = css`
  .device-header {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .title {
    margin: 0;
  }

  .device-header .header-logo {
    margin-right: 0.5rem;
  }
`

export const deviceFooterStyles = css`
  .device-footer {
    display: flex;
    justify-content: space-between;
    margin: 0 1rem;
  }
`

export const registerNewDeviceFormStyles = css`
  .register-new-device-form {
    width: 100%;
  }

  .register-new-device-input-container {
    min-height: 6rem;
  }

  .register-code-verification {
    margin-top: 0;
    margin-bottom: 2rem;
  }

  .register-button-container {
    display: flex;
    justify-content: center;
  }

  .register-button-container :global(.register-button) {
    padding: 0 2rem;
    font-weight: ${fontWeights.semiBold};
  }
`

export const dontShareCodeStyles = css`
  .security-warning {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1.5rem;
  }

  .security-warning :global(.security-warning-icon) {
    margin-right: 0.5rem;
    color: ${colors.frame};
  }
`
